import React, { useState } from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

import Container from "@mui/material/Container";
import * as Yup from "yup";
import { colors } from "../../theme/Colors";
import { TextField, IconButton, InputAdornment, FormControlLabel, Checkbox } from "@mui/material";
import { Formik, Form, Field, ErrorMessage } from "formik";
import { useSignupEntreprise } from "../../hooks/useSignupEntreprise";
import Alert from "@mui/material/Alert";
import Button from "@mui/material/Button";
import { useNavigate } from "react-router-dom";
import { useAuthContext } from "../../hooks/useAuthContext";
import logo from "../../imgs/imgV2/flextalent.png";
import CarouselSignup from "../../components/ui/CarouselSignup/CarouselSignup";
import FormikErrorText from "../../components/ui/FormikErrorText";
import { Visibility, VisibilityOff } from "@mui/icons-material";

function SignupEntreprise() {
  const [showPassword, setShowPassword] = useState(false);

  function handleClickShowPassword() {
    setShowPassword(!showPassword);
  }

  function handleMouseDownPassword(event) {
    event.preventDefault();
  }

  //navigate
  const navigate = useNavigate();

  const { user } = useAuthContext();

  //handle checkbox
  const [didAccept, setDidAccept] = useState(false);
  const handleChange = () => {
    setDidAccept(!didAccept);
  };

  //(ENTREPRISE) get response, error and isLoading from useSignupEntreprise hook
  const { signupEntreprise, errorSignupEntreprise, isLoadingEntreprise, successSignupEntreprise } = useSignupEntreprise();

  //validation for fields
  const validationSchemaEntreprise = Yup.object({
    email: Yup.string().email("Le format de l'email est invalide").required("Ce champs est obligatoire"),
    password: Yup.string().required("Ce champs est obligatoire").min(8, "Mot de passe trop court"),
    // passwordConfirmation: Yup.string()
    //   .required("Ce champs est obligatoire")
    //   .oneOf([Yup.ref("password"), null], "Le mot de passe ne correspond pas"),
    name: Yup.string().required("Ce champs est obligatoire"),
    siret: Yup.number()
      .typeError("Valeur invalide")
      .required("Ce champs est obligatoire")
      .test("is-14-digits", "Le numéro de siret doit avoir 14 chiffres", (value) => value && value.toString().length === 14),
  });

  //Form initial values
  const initialValuesEntreprise = {
    email: "",
    password: "",
    name: "",
    // role: "entreprise",
    siret: "",
    // passwordConfirmation: "",
  };

  //onSubmit ENTREPRISE Methode
  const onSubmitSignupEntreprise = async (values, errorSignupEntreprise, isLoadingEntreprise, successSignupEntreprise) => {
    await signupEntreprise(values.email, values.password, values.name, values.siret);
  };

  return (
    <Container maxWidth={"xl"}>
      <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", width: "100%" }}>
        <Box flex={1} display="flex" flexDirection="column" className="left" justifyContent="center" alignItems="center">
          <Box display="flex" width="100%" padding="32px 0px">
            <img width="210px" src={logo} alt="" />
          </Box>

          <Box sx={{ alignItems: "center", background: "white", width: "100%", maxWidth: "416px", padding: "16px 16px 64px 16px", minHeight: "586px", display: "flex", flexDirection: "column", justifyContent: "space-between" }}>
            <Box width="100%">
              <Box display="flex" flexDirection="column" textAlign="center" sx={{ marginBottom: "32px" }}>
                <Typography variant="text_xl" fontSize="25px" fontWeight="700">
                  Compte Entreprise
                </Typography>
                <Typography variant="text_normal" color={colors.text_subtitle}>
                  Veuillez remplir le formulaire afin de créer votre compte
                </Typography>
              </Box>
              <Formik initialValues={initialValuesEntreprise} validationSchema={validationSchemaEntreprise} onSubmit={onSubmitSignupEntreprise}>
                {({ values, error }) => (
                  <Form>
                    {/* Field for ENTREPRISE name */}
                    <Box sx={{ display: "flex", flexDirection: "column", marginBottom: "16px" }}>
                      <Box sx={{ marginBottom: "6px" }}>
                        <Typography variant="text_normal" fontWeight="600" htmlFor="Nom de l'entreprise" name="name">
                          Nom de l'entreprise
                        </Typography>
                        <Typography variant="text_normal" fontWeight="600" htmlFor="name" name="name" style={{ color: colors.main }}>
                          *
                        </Typography>
                      </Box>
                      <Field autoComplete="off" name="name" type="input" placeholder="Saisir le nom de votre entreprise" id="name" as={TextField} />
                      <ErrorMessage component={FormikErrorText} name="name" />
                    </Box>
                    {/* Field for siret */}
                    <Box sx={{ display: "flex", flexDirection: "column", marginBottom: "16px" }}>
                      <Box sx={{ marginBottom: "6px" }}>
                        <Typography variant="text_normal" fontWeight="600" htmlFor="Numero de siret" name="siret">
                          Numéro de siret
                        </Typography>{" "}
                        <Typography variant="text_normal" fontWeight="600" htmlFor="siret" name="siret" style={{ color: colors.main }}>
                          *
                        </Typography>
                      </Box>
                      <Field autoComplete="off" name="siret" type="input" placeholder="Saisir votre numéro de siret" id="siret" as={TextField}></Field>
                      <ErrorMessage component={FormikErrorText} name="siret" />
                    </Box>
                    {/* Field for mail */}
                    <Box sx={{ display: "flex", flexDirection: "column", marginBottom: "16px" }}>
                      <Box sx={{ marginBottom: "6px" }}>
                        <Typography variant="text_normal" fontWeight="600" htmlFor="email" name="email">
                          Email
                        </Typography>
                        <Typography variant="text_normal" fontWeight="600" htmlFor="email" name="email" style={{ color: colors.main }}>
                          *
                        </Typography>
                      </Box>
                      <Field autoComplete="off" name="email" type="email" placeholder="votre@email.com" id="email" as={TextField}></Field>
                      <ErrorMessage component={FormikErrorText} name="email" />
                    </Box>

                    {/* Field for password */}
                    {/* Field for password */}
                    <Box sx={{ display: "flex", flexDirection: "column", marginBottom: "16px" }}>
                      <Box sx={{ marginBottom: "6px" }}>
                        <Typography variant="text_normal" fontWeight="600" htmlFor="password" name="password">
                          Mot de passe
                        </Typography>
                        <Typography variant="text_normal" fontWeight="600" htmlFor="password" name="password" style={{ color: colors.main }}>
                          *
                        </Typography>
                      </Box>
                      <Field name="password" id="password">
                        {({ field, form, meta }) => (
                          <TextField
                            {...field}
                            fullWidth
                            placeholder="Saisir votre mot de passe"
                            autoComplete="Off"
                            type={showPassword ? "text" : "password"}
                            InputProps={{
                              endAdornment: (
                                <InputAdornment position="end" style={{ paddingRight: "12px" }}>
                                  <IconButton size="small" aria-label="toggle password visibility" onClick={handleClickShowPassword} onMouseDown={handleMouseDownPassword} edge="end">
                                    {showPassword ? <Visibility fontSize="12px" htmlColor="#9499A8" /> : <VisibilityOff fontSize="12px" htmlColor="#9499A8" />}
                                  </IconButton>
                                </InputAdornment>
                              ),
                            }}
                          />
                        )}
                      </Field>
                      <ErrorMessage component={FormikErrorText} name="password" />
                    </Box>
                    {/* Field for password confirmation */}
                    {/* <Box sx={{ display: "flex", flexDirection: "column", marginBottom: "16px" }}>
                      <Box sx={{ marginBottom: "6px" }}>
                        <Typography variant="text_normal" fontWeight="600" htmlFor="password" name="passwordConfirmation">
                          Confirmer mot de passe
                        </Typography>{" "}
                        <Typography variant="text_normal" fontWeight="600" htmlFor="email" name="email" style={{ color: colors.main }}>
                          *
                        </Typography>
                      </Box>
                      <Field as={TextField} name="passwordConfirmation" placeholder="Saisir votre mot de passe" id="passwordConfirmation" autoComplete="off">
                        {({ field, form, meta }) => <TextField {...field} fullWidth placeholder="Saisir votre mot de passe" autoComplete="Off" type={showPassword ? "text" : "password"} />}
                      </Field>
                      <ErrorMessage component={FormikErrorText} name="passwordConfirmation" />
                    </Box> */}
                    <Box sx={{ marginBottom: "32px", display: "flex", alignItems: "start" }}>
                      <FormControlLabel
                        control={
                          <Box>
                            <Checkbox disableRipple checked={didAccept} onChange={handleChange} name="terms" />
                          </Box>
                        }
                        sx={{
                          "& .MuiFormControlLabel-label": { fontSize: 14 }, // set the font size to 16px
                        }}
                      />
                      <Box marginTop="10px">
                        <Typography variant="text_normal">
                          J’atteste avoir lu et accepté les{" "}
                          <Typography onClick={() => window.open("wwww.google.com", "_blank")} variant="text_normal" sx={{ cursor: "pointer" }} fontWeight="600" color={colors.main}>
                            conditions générales d’utilisations
                          </Typography>{" "}
                          ainsi que la{" "}
                          <Typography onClick={() => window.open("wwww.google.com", "_blank")} variant="text_normal" sx={{ cursor: "pointer" }} fontWeight="600" color={colors.main}>
                            Politique de confidentialité
                          </Typography>{" "}
                          d’OhMyJob.
                        </Typography>
                      </Box>
                    </Box>

                    <Box display="flex" gap="10px" flexDirection="column">
                      <Box display="flex" justifyContent="center" alignItems="center">
                        <Button disabled={isLoadingEntreprise || didAccept === false} className="submit" type="submit" variant="mj_primary_md" fullWidth>
                          Créer votre compte
                        </Button>
                      </Box>
                      <Box display="flex" justifyContent="center" alignItems="center">
                        <Button onClick={() => navigate("/signup")} className="signup" variant="mj_secondary_md" fullWidth>
                          Précédent
                        </Button>
                      </Box>
                    </Box>

                    {errorSignupEntreprise && (
                      <Alert
                        sx={{
                          border: `1px solid  ${colors.mjRedOutline}`,
                          borderRadius: "12px",
                        }}
                        severity="error"
                      >
                        {errorSignupEntreprise}
                      </Alert>
                    )}
                    {successSignupEntreprise && (
                      <Alert
                        sx={{
                          border: `1px solid  ${colors.mjGreenOutline}`,
                          borderRadius: "12px",
                        }}
                        severity="success"
                      >
                        {successSignupEntreprise}
                      </Alert>
                    )}
                  </Form>
                )}
              </Formik>
            </Box>
          </Box>
        </Box>
        <Box flex={1.1} className="right" sx={{ padding: "32px 32px 32px 0px" }} width="50%" display={{ lg: "flex", xs: "none" }}>
          <CarouselSignup />
        </Box>
      </Box>
    </Container>
  );
}

// const Page = styled.div`
//   height: 100vh;
//   width: 100vw;
//   display: flex;
//   justify-content: center;
//   align-items: center;
//   background: ${colors.main};

//   .formContainer {
//     border-radius: 24px;
//     align-items: center;
//     padding: 1.5rem 3rem;
//     background: white;
//     width: 550px;
//     min-height: 600px;
//   }

//   .field {
//     display: flex;
//     flex-direction: column;
//     margin-bottom: 1rem;
//   }
//   .submit {
//     margin-bottom: 1rem;
//   }

//   label {
//     margin-bottom: 0.5rem;
//     //color: ${colors.tFieldGray};
//   }
// `;

export default SignupEntreprise;
